@if (!!allowedPortingDates()) {
  <app-ice-select-box
    label="Så fort som mulig"
    radioTestId="earliest-activation-date-select-box-input"
    [control]="isEarliestPortingTimeControl"
    [value]="true"
  >
    <div header>
      <span>Estimert:&nbsp;</span>
      @if (!isPorting && !orderSim) {
        <span>Innen 30 min</span>
      } @else {
        <span class="estimated-transfer-date">{{ estimatedTransferDateText }}</span>
      }
    </div>
  </app-ice-select-box>
  <app-ice-select-box
    label="Velg eget tidspunkt"
    radioTestId="activation-date-select-box-input"
    [control]="isEarliestPortingTimeControl"
    [disabled]="isPortingTimeSelectionDisabled"
    [hideOverflow]="false"
    [value]="false"
  >
    <div class="date-time-container">
      <app-ice-date-picker
        buttonTestId="subscription-activation-date-button"
        errorText="Datoen du har valgt er ikke tillatt"
        formControlName="activationDateTime"
        label="Dato"
        ngDefaultControl
        ngxsFormPath="formState.subscriptionForm"
        placeholder="dd.mm.yyyy"
        textTestId="subscription-activation-date-input"
        [allowedDates]="allowedPickerDates"
        [maxDate]="maxDate"
        [minDate]="minDate"
      />

      <app-ice-select
        buttonTestId="porting-time-select-button"
        formControlName="portingTime"
        inputWidth="x-small"
        label="Tidspunkt"
        ngDefaultControl
        ngxsFormPath="formState.subscriptionForm"
        textTestId="porting-time-select-input"
        [appDisableControl]="!isPorting"
        [icon]="IconNames.ice_clock"
        [options]="portingTimes"
      />
    </div>
  </app-ice-select-box>

  @if (hasAutomaticallyDelayedActivationDate) {
    <app-ice-alert type="info" [iconName]="IconNames.ice_info">Aktiveringstidspunkt utsatt</app-ice-alert>
  }

  @if (isPortingTimeSelectionDisabled) {
    <app-ice-alert type="info" [iconName]="IconNames.ice_info">
      <div heading>Med EID blir eSIM aktivert så fort som mulig</div>
      <div>
        Aktivering med EID støtter foreløpig ikke aktivering frem i tid. Når den nye mobilen skrus på for første gang trigger
        den selv eSIM-aktivering med det nye abonnementet
      </div>
    </app-ice-alert>
  }
}
